<template>
  <span class="relative group flex justify-center">
    <span
      v-if="isCollaborator"
      class="absolute w-[12px] h-[3px] rounded-t-none rounded-b-[3px] bg-[var(--user-color)] top-[-6px] left-0 right-0 mx-auto z-[1] transition-transform duration-200 translate-y-[0px] group-hover:translate-y-[-3px]"
      :style="styleProps"
    />
    <span
      v-tooltip="options"
      class="rounded-[44px] shadow-[0_0_0_0_var(--user-color)] z-[0] text-white text-sm overflow-hidden text-center transition-shadow duration-200"
      :class="{
        'cursor-pointer group-hover:shadow-[0_0_0_3px_var(--user-color)]': isCollaborator,
      }"
      :style="styleProps"
    >
      <Avatar
        :rounded="true"
        :color="color"
        :src="avatarUrl || gravatarUrl"
        :alt="shortName"
        :initials="shortName"
      />
    </span>
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { Avatar } from '@ui/components/avatar';

const props = defineProps({
  shortName: {
    type: String,
    default: null,
  },
  name: {
    type: String,
    default: null,
  },
  avatarUrl: {
    type: String,
    default: null,
  },
  color: {
    type: String,
    default: null,
  },
  gravatarUrl: {
    type: String,
    default: null,
  },
  tooltip: {
    type: Boolean,
    default: true,
  },
  isCollaborator: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['clickEvent']);

const styleProps = computed(() => {
  return { '--user-color': props.color };
});

const showTooltip = computed(() => {
  return props.tooltip ? props.name : '';
});

const options = computed(() => {
  return {
    content: showTooltip.value,
    placement: 'bottom',
    disabled: !props.tooltip,
  };
});
</script>
